import React, { useState } from 'react';
import { useAuth } from '../../context';

const SBALogin = () => {
  const [email, setEmail] = useState('admin@sba.com');
  const [password, setPassword] = useState('admin123');
  const [error, setError] = useState('');
  const { loginSBA } = useAuth();  // Change this line

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const result = await loginSBA(email, password);  // Change this line
    if (!result.success) {
      setError(result.message || 'Login failed');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-4">
          <div className="card">
            <div className="card-header bg-danger text-white">
              <h4>SBA Login</h4>
            </div>
            <div className="card-body">
              {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={handleSubmit}>
                <input type="email" className="form-control mb-2" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
                <input type="password" className="form-control mb-2" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
                <button type="submit" className="btn btn-danger w-100">Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SBALogin;